exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar[data-v-7cd37d20]{height:60px;overflow:hidden;position:relative;border-bottom:1px solid #dcdfe6;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navbar .main-menu[data-v-7cd37d20]{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:hidden;height:60px}", ""]);

// exports
